var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n-toast"},[_c('div',{staticClass:"toast-box",class:`toast-${_vm.color}`},[(_vm.icon)?_c('div',{staticClass:"toast-icon"},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_c('div',{staticClass:"toast-message"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }